import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Badge, Alert, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ModalFooter, ModalBody, ModalHeader, Modal, Input, Label } from "reactstrap";
import { withTranslation } from "react-i18next";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getBookingDetails, getBookingDetailsV2, getBookingPayment, cancelBooking,sendEmailConfirmation, sendGroupEmailConfirmation,downloadTicketByBookingNo, getBookingSlotById } from "api";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const BookingDetails = (props) => {
  document.title = "Booking Details | EventoX";
  const { bookingNo } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [action, setAction] = useState(null);
  const [reason, setReason] = useState("");
  const [refundAmount, setRefundAmount] = useState(0);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [primaryBookingNo, setPrimaryBookingNo] = useState(null);
  const [downloadingTicket, setDownloadingTicket] = useState(false);
  const [paymentSession, setPaymentSession] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [showPaymentJson, setShowPaymentJson] = useState(false);
  // Slot details from GET /api/booking-slot/{id} when the primary booking has a slotId
  const [slotDetails, setSlotDetails] = useState(null);


  useEffect(() => {
    if (bookingNo) {
      fetchBookingDetails();
    }
  }, [bookingNo]);

  useEffect(() => {
    // Load Stripe Checkout session details (if available) for the primary booking.
    // This matches the curl: GET /api/booking/payment/:bookingNo
    if (primaryBookingNo) {
      fetchPaymentSession(primaryBookingNo);
    }
  }, [primaryBookingNo]);

  const fetchPaymentSession = async (refNo) => {
    try {
      setPaymentLoading(true);
      setPaymentError("");
      setShowPaymentJson(false);
      const data = await getBookingPayment(refNo);
      setPaymentSession(data);
    } catch (err) {
      console.error("Error fetching payment session:", err);
      setPaymentSession(null);
      setPaymentError("Failed to fetch payment session");
    } finally {
      setPaymentLoading(false);
    }
  };

  const fetchBookingDetails = async () => {
    try {
      setLoading(true);
      const data = await getBookingDetailsV2(bookingNo);
      console.log("Booking details ->", data);
      setBookingDetails(data);
      const filterByBookedBy = data.filter(item => item.bookedBy === "0" || item.bookedBy === 0);
      if (filterByBookedBy.length > 0) {
        setPrimaryBookingNo(filterByBookedBy[0].primaryBookingNo);
        console.log("Slot ID ->", filterByBookedBy[0].slotId);
        setBooking(filterByBookedBy[0]);

        // If this booking is tied to a slot, load slot name/id for the Slot Details card
        const slotId = filterByBookedBy[0].slotId;
        if (slotId !== null && slotId !== undefined && slotId !== "") {
          try {
            const slotData = await getBookingSlotById(slotId);
            setSlotDetails(slotData);
          } catch (slotErr) {
            console.error("Error fetching booking slot:", slotErr);
            setSlotDetails(null);
          }
        } else {
          setSlotDetails(null);
        }
      } else {
        setPrimaryBookingNo(data[0].primaryBookingNo);
        setBooking(data[0]);
        setSlotDetails(null);
      }
    } catch (err) {
      setError("Failed to fetch booking details");
      console.error("Error fetching booking details:", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      confirmed: { color: "success", icon: "bx-check-circle" },
      pending: { color: "warning", icon: "bx-time" },
      cancelled: { color: "danger", icon: "bx-x-circle" },
      paid: { color: "success", icon: "bx-check-circle" },
      unpaid: { color: "warning", icon: "bx-time" },
      failed: { color: "danger", icon: "bx-x-circle" },
      cancelled_by_user: { color: "danger", icon: "bx-x-circle" },
      cancelled_by_organizer: { color: "danger", icon: "bx-x-circle" },
      cancelled_by_admin: { color: "danger", icon: "bx-x-circle" },
      cancelled_by_system: { color: "danger", icon: "bx-x-circle" },
      expired: { color: "danger", icon: "bx-x-circle" },
      confirmed: { color: "success", icon: "bx-check-circle" },
      pending: { color: "warning", icon: "bx-time" },

    };
    if (!status) return null;

    const config = statusConfig[status] || { color: "secondary", icon: "bx-question-mark" };

    return (
      <Badge color={config.color} className="fs-6">
        <i className={`bx ${config.icon} me-1`}></i>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </Badge>
    );
  };

  const getCheckInStatus = (checkIn) => {
    return checkIn ? (
      <Badge color="success" className="fs-6">
        <i className="bx bx-check-circle me-1"></i>
        Checked In
      </Badge>
    ) : (
      <Badge color="secondary" className="fs-6">
        <i className="bx bx-time me-1"></i>
        Not Checked In
      </Badge>
    );
  };
  const handleCancelBooking = async () => {
    if (!booking) return;
    if (action==="cancel" && (!reason || !reason.trim())) {
      alert("Enter a reason to cancel.");
      return;
    }

    try {
      setLoading(true);

   

      const payload = {
        primaryBookingNo: primaryBookingNo,
        refundAmount:action==="cancel"?refundAmount:0,
        cancellationReason:action==="cancel"?reason.trim():null,
        bookingStatus:action==="cancel"?"cancelled_by_admin":action==="refund"?"refunded_by_admin":action==="expired"?"expired_by_admin":action==="confirmed"?"confirmed":null,
      };

      console.log("Cancel payload ->", payload);
      const res = await cancelBooking(payload);
      await fetchBookingDetails();
      setAction(null);
      setReason("");
    } catch (err) {
      console.error("Cancel failed", err);
      setError(err.message || "Cancel failed");
    } finally {
      setLoading(false);
    }
  };

    const handleSendConfirmation = async () => {
      try {
        setLoading(true);
        const res = await sendGroupEmailConfirmation(primaryBookingNo);
        console.log("Email sent successfully:", res);
        toast.success("Email sent successfully!");
       }catch (error) {
        console.error("Error sending email confirmation:", error);
        toast.error("Failed to send email confirmation.");
    }finally {
        setLoading(false);
      }
    }

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading booking details...</p>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">
            <i className="bx bx-error-circle me-2"></i>
            {error}
          </Alert>
        </Container>
      </div>
    );
  }

  if (!booking) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="warning">
            <i className="bx bx-info-circle me-2"></i>
            Booking not found
          </Alert>
        </Container>
      </div>
    );
  }
const handleDownloadTicket = async () => {
    try {
        setDownloadingTicket(true);
        const response = await downloadTicketByBookingNo(primaryBookingNo);
        if (response) {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } else {
            toast.error("Failed to download ticket.");
        }
    } catch (error) {
        toast.error("Failed to download ticket.");
    } finally {
        setDownloadingTicket(false);
    }
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title="Reports"
            breadcrumbItem="Booking Details"
          />

          {/* Header */}
          <Card className="mb-4">
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 className="card-title mb-1">
                    <i className="bx bx-receipt me-2 text-primary"></i>
                    Booking Details
                  </h4>
                  <p className="text-muted mb-0">Booking No: {booking.bookingNo}</p>
                </div>
                <div className="d-flex gap-2">
                  {getStatusBadge(booking.bookingStatus)}
                  {getStatusBadge(booking.paymentStatus)}
                  {getCheckInStatus(booking.checkIn)}
                </div>
              </div>

              <div className="d-flex gap-2">
                <Button
                  color="secondary"
                  onClick={() => navigate(-1)}
                  className="mb-3"
                >
                  <i className="bx bx-arrow-back me-2"></i>
                  Back
                </Button>

                <UncontrolledDropdown className="mb-3">
                  <DropdownToggle caret color="danger">
                    Actions
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        setAction("cancel");
                      }}
                    >
                      <i className="bx bx-x-circle me-2"></i>
                      Cancel
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setAction("refund");
                      }}
                    >
                      <i className="bx bx-undo me-2"></i>
                      Refund
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setAction("expired");
                      }}
                    >
                      <i className="bx bx-time me-2"></i>
                      Expired
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setAction("confirmed");
                      }}
                    >
                      <i className="bx bx-check-circle me-2"></i>
                      Confirmed
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                
                <Button onClick={handleSendConfirmation}
                  color="primary"
                  disabled={loading}
                  className="mb-3"
                >
                  <i className="bx bxs-envelope me-2"></i>
                  send confirmation
                </Button>
                {booking.bookingStatus === 'confirmed' && (
                <Button
                    color="success"
                    onClick={handleDownloadTicket}
                    disabled={downloadingTicket}
                    className="mb-3"
                >
                    <i className="bx bx-download me-2"></i>
                    {downloadingTicket ? 'Downloading...' : 'Download Ticket'}
                </Button>
            )}

                {/* <Button
                  color="primary"
                  onClick={() => navigate('/admin/report/revenue-report')}
                  className="mb-3"
                >
                  <i className="bx bx-chart me-2"></i>
                  Back to Revenue Report
                </Button> */}
              </div>
            </CardBody>
          </Card>

          <Row>
            {/* Booking Information */}
            <Col lg={8}>
              <Card className="mb-4">
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-info-circle me-2 text-primary"></i>
                    Booking Information
                  </h5>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Booking Number</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.bookingNo}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Primary Booking No</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.primaryBookingNo}</p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Event</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Event?.eventName || "N/A"}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Organizer</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Organizer?.name || "N/A"}</p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Ticket Type</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.TicketType?.ticketType || "N/A"}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Venue</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Venue?.venueName || "N/A"}</p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Created Date</label>
                        <p className="mb-0 fs-5 fw-bold">{moment(booking.createdAt).format("DD MMM YYYY, h:mm A")}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Updated Date</label>
                        <p className="mb-0 fs-5 fw-bold">{moment(booking.updatedAt).format("DD MMM YYYY, h:mm A")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* Slot Details — only shown when GET /api/booking-slot/{id} returned data */}
              {slotDetails && (
                <Card className="mb-4">
                  <CardBody>
                    <h5 className="card-title mb-4">
                      <i className="bx bx-time-five me-2 text-primary"></i>
                      Slot Details
                    </h5>

                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold text-muted">Slot ID</label>
                          <p className="mb-0 fs-5 fw-bold">{slotDetails.id}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold text-muted">Slot Name</label>
                          <p className="mb-0 fs-5 fw-bold">{slotDetails.slotName || "N/A"}</p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}

              {/* Contact Information */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-user me-2 text-primary"></i>
                    Contact Information
                  </h5>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">First Name</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Contact?.firstName || "N/A"}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Last Name</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Contact?.lastName || "N/A"}</p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Email</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Contact?.email || "N/A"}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-muted">Phone</label>
                        <p className="mb-0 fs-5 fw-bold">{booking.Contact?.phoneNo || "N/A"}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* Attendees */}
              {bookingDetails && bookingDetails.length > 0 && (
                <Card className="mb-4">
                  <CardBody>
                    <h5 className="card-title mb-4">
                      <i className="bx bx-group me-2 text-primary"></i>
                      Attendees ({bookingDetails.length})
                    </h5>

                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Age</th>
                            <th>Ticket Type</th>
                            <th>Ticket Price</th>

                          </tr>
                        </thead>
                        <tbody>
                          {bookingDetails.map((attendee, index) => (
                            <tr key={index}>
                              <td>{`${attendee?.Contact?.firstName} ${attendee?.Contact?.lastName}`}</td>
                              <td>{attendee?.Contact?.email || "N/A"}</td>
                              <td>{attendee?.Contact?.age || "N/A"}</td>
                              <td>{attendee?.TicketType?.ticketType || "N/A"}</td>
                              <td>{attendee?.TicketType?.price || "N/A"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>

            {/* Financial Information */}
            <Col lg={4}>
              <Card className="mb-4">
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-dollar-circle me-2 text-primary"></i>
                    Financial Details
                  </h5>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Total Ticket Count</span>
                    <span className="fs-5 fw-bold">{booking.totalTicketCount}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Ticket Amount</span>
                    <span className="fs-5 fw-bold text-primary">₹{Number(booking.totalTicketAmount || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Processing Fee</span>
                    <span className="fs-5 fw-bold text-warning">₹{Number(booking.processingFee || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Ticket Fee</span>
                    <span className="fs-5 fw-bold text-info">₹{Number(booking.ticketFee || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Discount Amount</span>
                    <span className="fs-5 fw-bold text-success">₹{Number(booking.discountAmount || 0).toFixed(2)}</span>
                  </div>

                  <hr />

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold fs-5">Grand Total</span>
                    <span className="fs-4 fw-bold text-success">₹{Number(booking.grandTotal || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Currency</span>
                    <span className="fs-5 fw-bold">{booking.currency}</span>
                  </div>
                </CardBody>
              </Card>

              {/* Revenue Breakdown */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-pie-chart me-2 text-primary"></i>
                    Revenue Breakdown
                  </h5>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Stripe Revenue</span>
                    <span className="fs-5 fw-bold text-danger">₹{Number(booking.stripeRevenue || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Eventox Revenue</span>
                    <span className="fs-5 fw-bold text-success">₹{Number(booking.eventoxRevenue || 0).toFixed(2)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">Organizer Revenue</span>
                    <span className="fs-5 fw-bold text-primary">₹{Number(booking.organizerRevenue || 0).toFixed(2)}</span>
                  </div>
                </CardBody>
              </Card>

              {/* Payment Information */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-credit-card me-2 text-primary"></i>
                    Payment Information
                  </h5>

                  <div className="mb-3">
                    <label className="form-label fw-semibold text-muted">Payment Reference</label>
                    <p className="mb-0 fs-6 text-break">{booking.paymentReferance || "N/A"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold text-muted">Stripe Session ID</label>
                    <p className="mb-0 fs-6 text-break">{booking.stripSessionId || "N/A"}</p>
                  </div>

                  <div className="d-flex gap-2 mb-3">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => fetchPaymentSession(primaryBookingNo || booking.bookingNo)}
                      disabled={paymentLoading || !(primaryBookingNo || booking?.bookingNo)}
                    >
                      <i className={`bx ${paymentLoading ? "bx-loader-alt bx-spin" : "bx-cloud-download"} me-2`}></i>
                      {paymentLoading ? "Loading Payment..." : "Load Payment Session"}
                    </Button>

                    {paymentSession && (
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => setShowPaymentJson(v => !v)}
                      >
                        <i className="bx bx-code-block me-2"></i>
                        {showPaymentJson ? "Hide JSON" : "View JSON"}
                      </Button>
                    )}
                  </div>

                  {paymentError && (
                    <Alert color="danger" className="py-2">
                      <i className="bx bx-error-circle me-2"></i>
                      {paymentError}
                    </Alert>
                  )}

                  {paymentSession && (
                    <div className="mb-3">
                      <label className="form-label fw-semibold text-muted">Payment Session Summary</label>
                      <div className="small text-muted">
                        <div><strong>Status:</strong> {paymentSession.status || "—"} | <strong>Payment:</strong> {paymentSession.payment_status || "—"}</div>
                        <div><strong>Currency:</strong> {String(paymentSession.currency || "—").toUpperCase()}</div>
                        <div>
                          <strong>Amount Total:</strong>{" "}
                          {typeof paymentSession.amount_total === "number"
                            ? (paymentSession.amount_total / 100).toFixed(2)
                            : "—"}
                        </div>
                        <div><strong>Payment Intent:</strong> {paymentSession.payment_intent || "—"}</div>
                        <div><strong>Customer Email:</strong> {paymentSession.customer_details?.email || "—"}</div>
                      </div>
                    </div>
                  )}

                  {paymentSession && showPaymentJson && (
                    <div className="mb-3">
                      <label className="form-label fw-semibold text-muted">Raw Payment Session JSON</label>
                      <pre
                        className="bg-light p-2 rounded small"
                        style={{ maxHeight: 260, overflow: "auto", whiteSpace: "pre-wrap" }}
                      >
                        {JSON.stringify(paymentSession, null, 2)}
                      </pre>
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label fw-semibold text-muted">Coupon Code</label>
                    <p className="mb-0 fs-6">{booking.couponCode || "N/A"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold text-muted">Expires At</label>
                    <p className="mb-0 fs-6">{booking.expiresAt ? moment(booking.expiresAt).format("DD MMM YYYY, h:mm A") : "N/A"}</p>
                  </div>

                  {booking.checkInDateTime && (
                    <div className="mb-3">
                      <label className="form-label fw-semibold text-muted">Check-in Date</label>
                      <p className="mb-0 fs-6">{moment(booking.checkInDateTime).format("DD MMM YYYY, h:mm A")}</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Modal isOpen={!!action} toggle={() => setAction(null)}>
              <ModalHeader toggle={() => setAction(null)}>
                {action === "cancel" && "Cancel Booking"}
                {action === "refund" && "Refund Booking"}
                {action === "expired" && "Mark as Expired"}
                {action === "confirmed" && "Confirm Booking"}
              </ModalHeader>

              <ModalBody>
                <p><strong>Booking No:</strong> {booking?.primaryBookingNo}</p>

                {action === "cancel" && (
                  <>
                    <Label for="refundAmount">Refund Amount</Label>
                    <Input
                      type="text"
                      id="refundAmount"
                      value={refundAmount}
                      onChange={(e) => setRefundAmount(e.target.value)}
                    
                      className="mb-3"
                    />
                    <Label for="reason">Reason for cancellation</Label>
                    <Input
                      type="textarea"
                      id="reason"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder="Enter cancellation reason"
                    />
                    <p className="text-danger mt-2">
                      Are you sure you want to cancel this booking?
                    </p>
                  </>
                )}

                {action === "refund" && (
                  <p className="text-warning">Are you sure you want to refund this booking?</p>
                )}
                {action === "expired" && (
                  <p className="text-warning">Mark this booking as expired?</p>
                )}
                {action === "confirmed" && (
                  <p className="text-success">Confirm this booking?</p>
                )}
              </ModalBody>

              <ModalFooter>
                <Button color="secondary" onClick={() => setAction(null)}>Back</Button>
                <Button
                  color="primary"
                  disabled={loading || (action === "cancel" && !reason.trim())}
                  onClick={async () => {
                    await handleCancelBooking();
                    setAction(null);
                  }}
                >
                  Confirm
                </Button>
              </ModalFooter>
            </Modal>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(BookingDetails); 